/**
  AGV路由配置
*/
import { lazy } from 'ice';
import React from 'react';
import AutoMation from '@/pages/AutoMation';
import AutoMationDown from '@/pages/AutoMationDown';
import AutoMationDetail from '@/pages/AutoMationDetail';
import AutoMationDownDetails from '@/pages/AutoMationDownDetails';
import AutoMationUp from '@/pages/AutoMationUp';
import AutoMationUpDetails from '@/pages/AutoMationUpDetails';
import AutoMationMoveDown from '@/pages/AutoMationMoveDown';
import AutoMationMoveDownDetail from '@/pages/AutoMationMoveDownDetails';
import AutoTally from '@/pages/AutoTally';
import AutoTallyDetail from '@/pages/AutoTallyDetail';

import AutoMationUpManage from '@/pages/AutoMationUpManage';
import AutoMationDownManage from '@/pages/AutoMationDownManage';
import UpManageCreate from '@/pages/AutoMationUpManage/components/CreateCom';
import DownManageCreate from '@/pages/AutoMationDownManage/components/CreateCom';
import AutoMationRepleSku from '@/pages/AutoMationRepleSku';

import AutoMationReconc from '@/pages/AutoMationReconc';
import AutoSkuManage from '@/pages/AutoSkuManage';
import AutoAbnormalStock from '@/pages/AutoAbnormalStock';
import AutoStockAjust from '@/pages/AutoStockAjust';

// import AmrPackingOffShelfList from '@/pages/AmrPackingOffShelf/List/index';
// import AmrPackingOffShelfDetail from '@/pages/AmrPackingOffShelf/Detail/index';
import AmrPackingOffShelfDetailOld from '@/pages/AmrPackingOffShelf/DetailOld';
import AmrPackingOffShelfListOld from '@/pages/AmrPackingOffShelf/ListOld';
// const AutoMation = lazy(() => import(/* webpackChunkName: 'AutoMation' */ '@/pages/AutoMation'));
// const AutoMationDown = lazy(() => import(/* webpackChunkName: 'AutoMationDown' */ '@/pages/AutoMationDown'));
// const AutoMationDetail = lazy(() => import(/* webpackChunkName: 'AutoMationDetail' */ '@/pages/AutoMationDetail'));
// const AutoMationDownDetails = lazy(
//   () => import(/* webpackChunkName: 'AutoMationDownDetails' */ '@/pages/AutoMationDownDetails'),
// );
// const AutoMationUp = lazy(() => import(/* webpackChunkName: 'AutoMationUp' */ '@/pages/AutoMationUp'));
// const AutoMationUpDetails = lazy(
//   () => import(/* webpackChunkName: 'AutoMationUpDetails' */ '@/pages/AutoMationUpDetails'),
// );
// const AutoMationMoveDown = lazy(
//   () => import(/* webpackChunkName: 'AutoMationMoveDown' */ '@/pages/AutoMationMoveDown'),
// );
// const AutoMationMoveDownDetail = lazy(
//   () => import(/* webpackChunkName: 'AutoMationMoveDownDetails' */ '@/pages/AutoMationMoveDownDetails'),
// );
// const AutoMationReconc = lazy(() => import(/* webpackChunkName: 'AutoMationReconc' */ '@/pages/AutoMationReconc'));
// const AutoSkuManage = lazy(() => import(/* webpackChunkName: 'AutoSkuManage' */ '@/pages/AutoSkuManage'));
// const AutoMationUpManage = lazy(
//   () => import(/* webpackChunkName: 'AutoMationUpManage' */ '@/pages/AutoMationUpManage'),
// );
// const AutoMationDownManage = lazy(
//   () => import(/* webpackChunkName: 'AutoMationDownManage' */ '@/pages/AutoMationDownManage'),
// );
// const UpManageCreate = lazy(
//   () => import(/* webpackChunkName: 'UpManageCreate' */ '@/pages/AutoMationUpManage/components/CreateCom'),
// );
// const DownManageCreate = lazy(
//   () => import(/* webpackChunkName: 'DownManageCreate' */ '@/pages/AutoMationDownManage/components/CreateCom'),
// );

export default [
  {
    path: '/automation/automation/list',
    // component: AutoMation,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMation' */ '@/pages/AutoMation')),
  },
  {
    path: '/automation/automation/AutoMationDown',
    // component: AutoMationDown,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationDown' */ '@/pages/AutoMationDown')),
  },
  {
    path: '/automation/automation/AutoMationDetail/:tid',
    // component: AutoMationDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationDetail' */ '@/pages/AutoMationDetail')),
  },
  {
    path: '/automation/automation/AutoMationDownDetails/:tid',
    // component: AutoMationDownDetails,
    component: React.lazy(
      () => import(/* webpackChunkName: 'AutoMationDownDetails' */ '@/pages/AutoMationDownDetails'),
    ),
  },
  {
    path: '/automation/automation/AutoMationUp',
    // component: AutoMationUp,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationUp' */ '@/pages/AutoMationUp')),
  },
  {
    path: '/automation/automation/AutoMationUpDetails/:tid',
    // component: AutoMationUpDetails,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationUpDetails' */ '@/pages/AutoMationUpDetails')),
  },
  {
    path: '/automation/automation/AutoMationMoveDown',
    // component: AutoMationMoveDown,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationMoveDown' */ '@/pages/AutoMationMoveDown')),
  },
  {
    path: '/automation/automation/AutoMationMoveDownDetails/:tid',
    // component: AutoMationMoveDownDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'AutoMationMoveDownDetail' */ '@/pages/AutoMationMoveDownDetails'),
    ),
  },

  {
    path: '/automation/automation/tally',
    // component: AutoTally,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoTally' */ '@/pages/AutoTally')),
  },

  {
    path: '/automation/automation/tallyDetail/:tid',
    // component: AutoTallyDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoTallyDetail' */ '@/pages/AutoTallyDetail')),
  },

  {
    path: '/automation/automation/automationupmanage',
    // component: AutoMationUpManage,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationUpManage' */ '@/pages/AutoMationUpManage')),
  },

  {
    path: '/automation/automation/addmationupmanage',
    // component: UpManageCreate,
    component: React.lazy(
      () => import(/* webpackChunkName: 'UpManageCreate' */ '@/pages/AutoMationUpManage/components/CreateCom'),
    ),
  },

  {
    path: '/automation/automation/automationdownmanage',
    // component: AutoMationDownManage,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationDownManage' */ '@/pages/AutoMationDownManage')),
  },

  {
    path: '/automation/automation/addmationdownmanage',
    // component: DownManageCreate,
    component: React.lazy(
      () => import(/* webpackChunkName: 'DownManageCreate' */ '@/pages/AutoMationDownManage/components/CreateCom'),
    ),
  },

  {
    path: '/automation/automation/replesku',
    // component: AutoMationRepleSku,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationRepleSku' */ '@/pages/AutoMationRepleSku')),
  },

  {
    path: '/automation/automation/AutoMationReconc',
    // component: AutoMationReconc,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoMationReconc' */ '@/pages/AutoMationReconc')),
  },

  {
    path: '/automation/automation/AutoSkuManage',
    // component: AutoSkuManage,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoSkuManage' */ '@/pages/AutoSkuManage')),
  },

  {
    path: '/automation/automation/abnormalstock',
    // component: AutoAbnormalStock,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoSkuManage' */ '@/pages/AutoAbnormalStock')),
  },

  {
    path: '/automation/automation/autostockajust',
    // component: AutoStockAjust,
    component: React.lazy(() => import(/* webpackChunkName: 'AutoStockAjust' */ '@/pages/AutoStockAjust')),
  },

  // {
  //   path: '/automation/packingOffShelf/list',
  //   component: AmrPackingOffShelfList,
  // },
  // {
  //   path: '/automation/packingOffShelf/detail',
  //   component: AmrPackingOffShelfDetail,
  // },
  {
    path: '/automation/packingOffShelf/detail',
    // component: AmrPackingOffShelfDetailOld, '@/pages/AmrPackingOffShelf/DetailOld'
    component: React.lazy(
      () => import(/* webpackChunkName: 'AmrPackingOffShelfDetailOld' */ '@/pages/AmrPackingOffShelf/DetailOld'),
    ),
  },
  {
    path: '/automation/packingOffShelf/list',
    // component: AmrPackingOffShelfListOld,
    component: React.lazy(
      () => import(/* webpackChunkName: 'AmrPackingOffShelfDetailOld' */ '@/pages/AmrPackingOffShelf/ListOld'),
    ),
  },
];
